import { render, staticRenderFns } from "./GrantContractedResearch.vue?vue&type=template&id=239ae718&"
import script from "./GrantContractedResearch.vue?vue&type=script&lang=js&"
export * from "./GrantContractedResearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports